import request from '@/utils/request'

let CasesApi = {

  /*案例列表*/
  list(data) {
    return request._post('/shop/plus.cases.Index/index', data);
},
/*添加案例*/
add(data) {
    return request._post('/shop/plus.cases.Index/add', data);
},
/*修改案例*/
edit(data) {
    return request._post('/shop/plus.cases.Index/edit', data);
},
/*删除案例*/
del(data) {
    return request._post('/shop/plus.cases.Index/del', data);
},
/*案例详情*/
detail(data) {
  return request._post('/shop/plus.cases.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.cases.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.cases.Setting/getSetting', data, errorback);
    },
}
export default CasesApi;



// WEBPACK FOOTER //
// ./src/api/cases.js